import { useDispatch } from "react-redux";
import { ChatDispatch } from "../store/actions/types";

export function useChatDispatch(): ChatDispatch {
    return useDispatch<ChatDispatch>();
}
